import React from 'react';

import { SubscriptionTier } from '@invoice-simple/common';

import { getIntervalText, getTierPrice } from 'src/components/SubscriptionPaywall/utils';
import { useISIntl } from 'src/i18n';
import { Cadence } from 'src/models/UserModel';

interface CardPriceProps {
  name: SubscriptionTier;
  selectedInterval: Cadence;
}

export const CardPrice = ({ name, selectedInterval }: CardPriceProps) => {
  const { ft } = useISIntl();
  const { comparePrice, displayPrice } = getTierPrice(name, selectedInterval);
  const isDiscounted = !!comparePrice && comparePrice !== displayPrice;

  const intervalText = getIntervalText(selectedInterval, ft);

  return (
    <>
      {isDiscounted && <p className="line-through text-2xl">{comparePrice}</p>}
      <p
        className="text-[28px] font-extrabold text-gray-900 mt-1"
        data-testid={`desktop-${name}-price`}>
        {displayPrice}
        <span className="text-2xl font-semibold text-gray-500 ml-1">{intervalText}</span>
      </p>
    </>
  );
};
